export default [
    {
        path: '/clients/grid',
        name: 'ClientsGrid',
        meta: { authRequired: true },
        component: () => import('../views/clients/grid.vue'),
    },
    {
        path: '/clients/add-clients',
        name: 'AddClients',
        meta: {authRequired: true},
        component: () => import('../../components/_dispatchers/clients/AddClients'),
    },
    {
        path: '/dispatcher/client/new-clients',
        name: 'new-clients',
        meta: {authRequired: true},
        component: () => import('../../components/_dispatchers/clients/notActiveClients'),
    },
    {
        path: '/dispatcher/client/suspects-clients',
        name: 'suspects-clients',
        meta: {authRequired: true},
        component: () => import('../../components/_dispatchers/clients/suspects'),
    },
    {
        path: '/dispatcher/client/active-order-clients',
        name: 'active-order-clients',
        meta: {authRequired: true},
        component: () => import('../../components/_dispatchers/clients/moreOrderedClients'),
    },
]
